import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Item } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const TotalPointsCash = ({ paymentPoints, installmentSelected, isMobile }) => {
  const installment = installmentSelected()
  if (!installment) return ''

  return (
    <Fragment>
      <Item
        description='Valor em Pontos:'
        className={`row product-brand pt-2 ${isMobile ? 'px-0' : 'px-2'}`}
        classFont='total-points txt-body-sm color-ui-2'
      >
        <CatalogCurrencyLabel className='txt-bold color-brand-1' value={paymentPoints} />
      </Item>
      <Item
        description={`Valor em ${process.env.REACT_APP_PAYMENT_COMPLEMENT_TEXT || 'dinheiro'}:`}
        className={`row product-brand pt-1 ${isMobile ? 'px-0' : 'px-2'}`}
        classFont='total-points txt-body-sm color-ui-2'
      >
        <p className='txt-bold color-brand-1'>+ {installment.description}</p>
      </Item>
    </Fragment>
  )
}

TotalPointsCash.propTypes = {
  paymentPoints: PropTypes.number.isRequired,
  installmentSelected: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
}

export default TotalPointsCash



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/TotalPointsCash.js